export const uiConstant = {
    SET_SIDE_MENU_ACTIVE_ITEM: 'SET_SIDE_MENU_ACTIVE_ITEM',
};

export default uiConstant;